import "./Footer.css";

export default function Footer() {

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    return (
        <footer className="footer-adx">
            <div className="container">

                <div className="row gy-4">

                    {/* LOGO + TEXTO */}
                    <div className="col-md-4 text-center text-md-start">
                        <img
                            src="/imgs/logomacaparanafooter.png"
                            alt="Prefeitura"
                            className="footer-logo"
                        />

                        <p className="footer-text mt-3">
                            Garanta mais eficiência e cuidado na <br />merenda escolar do seu município.
                        </p>

                        <div className="footer-social mt-3">
                            <i className="bi bi-instagram"></i>
                            <i className="bi bi-facebook"></i>
                        </div>
                    </div>

                    {/* NAVEGAÇÃO */}
                    <div className="col-md-3 text-center text-md-start">
                        <h6>Navegação</h6>
                        <ul>
                            <li><a href="#sobre" style={{ color: 'white', textDecoration: 'none' }}>Sobre o Projeto</a></li>
                            <li><a href="#como" style={{ color: 'white', textDecoration: 'none' }}>Como Funciona</a></li>
                            <li><a href="#beneficios" style={{ color: 'white', textDecoration: 'none' }}>Benefícios</a></li>
                            <li><a href="#duvidas" style={{ color: 'white', textDecoration: 'none' }}>Dúvidas</a></li>
                        </ul>
                    </div>

                    {/* ACESSOS RÁPIDOS */}
                    <div className="col-md-3 text-center text-md-start">
                        <h6>Acessos Rápidos</h6>
                        <ul>
                            <li ><a href="/questionario" style={{ color: 'white', textDecoration: 'none' }}>Acessar Questionário</a></li>
                        </ul>
                    </div>

                    {/* ASPECTOS LEGAIS */}
                    <div className="col-md-2 text-center text-md-start">
                        <h6>Aspectos Legais</h6>
                        <ul>
                            {/* <li><a href="https://homologacao.adxhealth.com.br/privacidade.html" target="blank_" style={{ color: 'white', textDecoration: 'none' }}>Política de Privacidade</a></li> */}
                            <li>Política de Privacidade</li>
                            <li>Termos de Uso</li>
                        </ul>
                    </div>

                </div>

                <hr className="footer-divider" />

                {/* RODAPÉ FINAL */}
                <div className="footer-bottom d-flex flex-column flex-md-row justify-content-between align-items-center text-center gap-3">
                    <span>
                        © Prefeitura Municipal de Macaparanã, CNPJ: 11.361.888/0001-04
                    </span>

                    <div className="footer-brands">
                        <img src="/imgs/logosadx.png" alt="ADX" />
                    </div>
                </div>

            </div>
        </footer>
    );
}
